import React, { useState } from 'react'
import moment from 'moment'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Menu, MenuItem, Modal } from '@mui/material'
import AccessLogs from '../EPCRView/AccessLogs'

const Header = ({ record }) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const [showAccessLogs, setShowAccessLogs] = useState(false)

  return (
    <EPCRCard>
      <Stack>
        <Stack direction="row" gap={1} justifyContent="space-between">
          <Typography>Competitor: {record?.competitorNumber}</Typography>
          <Stack gap={1} direction="row">
            <Tooltip
              title={
                <Stack alignItems="center">
                  <Typography variant="caption">Created By</Typography>
                  <Typography fontWeight="bold">
                    {record.completedBy.firstName +
                      ' ' +
                      record.completedBy.lastName}
                  </Typography>
                </Stack>
              }
            >
              <Avatar
                src={record.completedBy.photograph}
                sx={{ borderRadius: 1, width: 24, height: 24 }}
              />
            </Tooltip>
            <Chip
              sx={{ borderRadius: 1 }}
              color={
                record?.review?.status === 'Draft'
                  ? 'error'
                  : record?.review?.status === 'Submitted'
                  ? 'success'
                  : 'info'
              }
              label={record?.review?.status ?? 'Submitted'}
              size="small"
            />
            <MoreVertIcon
              onClick={(e) => setMenuAnchorEl(e.currentTarget)}
              sx={{ cursor: 'pointer' }}
            />
          </Stack>
        </Stack>
      </Stack>
      <Menu
        open={!!menuAnchorEl}
        onClose={() => setMenuAnchorEl(null)}
        anchorEl={menuAnchorEl}
      >
        <MenuItem onClick={() => setShowAccessLogs(true)}>
          Show Access Logs
        </MenuItem>
        <MenuItem disabled>Download PDF</MenuItem>
      </Menu>

      <AccessLogs
        paperPCRID={record._id}
        open={showAccessLogs}
        onClose={() => setShowAccessLogs(false)}
      />
    </EPCRCard>
  )
}

export default Header
